import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { ResolutionService } from "../notification-resolver/resolution-service";

@Injectable({ providedIn: "root" })
export class RouteListenerService {
    constructor(
        private router: Router,
        private resolutionService: ResolutionService
    ) {
        this.listenToRouteChanges();
    }

    private listenToRouteChanges() {
        this.router.events
            .pipe(
                filter(
                    (event): event is NavigationEnd =>
                        event instanceof NavigationEnd
                )
            )
            .subscribe((event) => {
                this.resolutionService.clearPageCorrelationIds();
            });
    }
}
